export default __webpack_public_path__ + "static/media/Avatar-12.906522d3.svg";